import Vue from 'vue';

export const BlobImagesStore = {
    state: () => ({
        blobData: {},
        urlPath: '/config/bioderma',
        logoBioderma: '',
        logoNao: '',
        ImageProduct: '',
    }),
    mutations: {
        setBlobConfig: function(state, data) {
            if (data) {
                state.blobData = data?.image;
            }
        },
    },
    getters: {
        getLogoBioderma: function(state) {
            // state.logoBioderma = Vue.bzbsConfig.bzbsBlobUrl + '/config/bioderma/logo/navbar_logo_bioderma.svg';
            state.logoBioderma = Vue.bzbsConfig.bzbsBlobUrl + state.urlPath + state.blobData?.logo_biodema;
            return state.logoBioderma
        },
        getLogoNao: function(state) {
            state.logoNao = Vue.bzbsConfig.bzbsBlobUrl + state.urlPath + state.blobData?.logo_naos;
            return state.logoNao
        },
        getImageProduct: function(state) {
            state.ImageProduct = Vue.bzbsConfig.bzbsBlobUrl + state.urlPath + state.blobData?.packshot;
            return state.ImageProduct
        },
        getBgLogin: function(state) {
            state.ImageProduct = Vue.bzbsConfig.bzbsBlobUrl + state.urlPath + state.blobData?.bg_login;
            return state.ImageProduct
        },
        getBgLanding: function(state) {
            state.ImageProduct = Vue.bzbsConfig.bzbsBlobUrl + state.urlPath + state.blobData?.bg_landing;
            return state.ImageProduct
        },
    },
};